export const error = {
  // Erreurs de formulaire
  login_empty: "L'identifiant est obligatoire",
  password_empty: 'Le mot de passe est obligatoire',
  empty_field: 'Ce champ est obligatoire',
  email_format: 'Adresse email non valide',
  login_field: 'Le login doit contenir entre 2 et 30 caractères',
  endDate_field: "L'heure de fin doit être supérieure à l'heure de début",
  
  // Erreurs utilisateur/collaborateur
  user_login_exists: 'Ce login est déjà utilisé par un autre utilisateur',
  user_invalid_agency: "L'agence sélectionnée n'existe pas",
  user_invalid_role: 'Le rôle sélectionné est invalide',
  user_not_found: "L'utilisateur n'existe pas",
  user_invalid_email: "L'adresse email n'est pas valide",
  user_invalid_login_format: 'Le login doit contenir entre 2 et 30 caractères',
  user_missing_required_field: 'Un champ obligatoire est manquant',
  user_invalid_civility: 'La civilité sélectionnée est invalide',
  
  // Erreurs agence
  agency_not_found: "L'agence n'existe pas",
  
  // Erreurs intervention / service delivery
  sd_invalid_date: 'La date fournie est invalide',
  sd_invalid_patrimony: "Le patrimoine sélectionné n'existe pas",
  sd_invalid_type: 'Le type de prestation sélectionné est invalide',
  sd_types_required: 'Veuillez sélectionner au moins un type de prestation',
  sd_invalid_collaborator: "Le collaborateur sélectionné n'existe pas",
  sd_collaborator_wrong_agency: "Le collaborateur sélectionné n'appartient pas à votre agence",
  sd_invalid_time: "Le format de l'heure est invalide (HH:MM attendu)",
  sd_invalid_week_template: "Le modèle de semaine sélectionné n'existe pas",
  sd_create_failed: "Échec de la création de l'intervention",
  sd_not_found: "L'intervention n'existe pas",
  
  // Erreurs semaine type / job schedule
  wt_invalid_day_schedule: "Le planning journalier sélectionné n'existe pas",
  wt_corrupt_data: 'Le modèle de semaine est mal configuré (planning journalier manquant)',
  wt_not_found: "Le modèle de semaine n'existe pas",
  wt_job_create_failed: 'Échec de la création de la tâche planifiée',
  wt_type_assoc_failed: "Échec de l'association du type de prestation",
  wt_user_assoc_failed: "Échec de l'affectation du collaborateur",
  
  // Erreurs patrimoine
  pat_not_found: "Le patrimoine n'existe pas",
  pat_create_failed: 'Échec de la création/modification du patrimoine',
  pat_invalid_types: 'Les types de prestation sélectionnés sont invalides',
  
  // Erreurs génériques
  missing_parameter: 'Un paramètre requis est manquant',
  invalid_data: 'Les données fournies sont invalides',
  server_error: 'Erreur serveur, veuillez réessayer plus tard',
  unknow: 'Une erreur inattendue est survenue',
  
  // Erreurs HTTP
  bad_request: 'Requête invalide',
  unauthorized: 'Vous devez être connecté pour effectuer cette action',
  forbidden: "Vous n'avez pas les droits pour effectuer cette action",
  not_found: 'Ressource non trouvée',
  conflict: 'Conflit avec les données existantes',
  validation_error: 'Erreur de validation des données',
  service_unavailable: 'Service temporairement indisponible',
  
  // Erreurs réseau
  network: 'Erreur de connexion, vérifiez votre connexion internet',
  timeout: 'La requête a pris trop de temps, veuillez réessayer',
};
